import { Buoy } from '../types';

export function renderBuoy(
  ctx: CanvasRenderingContext2D,
  buoy: Buoy,
  isNext: boolean,
  isRounded: boolean,
  timestamp: number
) {
  ctx.save();
  ctx.translate(buoy.position.x, buoy.position.y);

  const bobOffset = Math.sin(timestamp * 0.002 + buoy.id) * 2;
  ctx.translate(0, bobOffset);

  if (isNext) {
    const pulseScale = 1 + Math.sin(timestamp * 0.005) * 0.15;
    ctx.beginPath();
    ctx.arc(0, 0, buoy.radius * 2 * pulseScale, 0, Math.PI * 2);
    ctx.fillStyle = 'rgba(255, 200, 0, 0.2)';
    ctx.fill();
  }

  ctx.beginPath();
  ctx.arc(0, 0, buoy.radius, 0, Math.PI * 2);

  if (isRounded) {
    ctx.fillStyle = '#2a5a2a';
  } else {
    const gradient = ctx.createRadialGradient(
      -buoy.radius * 0.3,
      -buoy.radius * 0.3,
      0,
      0,
      0,
      buoy.radius
    );
    gradient.addColorStop(0, '#ff4444');
    gradient.addColorStop(0.7, '#cc0000');
    gradient.addColorStop(1, '#990000');
    ctx.fillStyle = gradient;
  }
  ctx.fill();

  ctx.strokeStyle = isRounded ? '#1a3a1a' : '#660000';
  ctx.lineWidth = 2;
  ctx.stroke();

  ctx.beginPath();
  ctx.arc(
    -buoy.radius * 0.25,
    -buoy.radius * 0.25,
    buoy.radius * 0.3,
    0,
    Math.PI * 2
  );
  ctx.fillStyle = isRounded
    ? 'rgba(100, 200, 100, 0.4)'
    : 'rgba(255, 255, 255, 0.4)';
  ctx.fill();

  ctx.fillStyle = 'white';
  ctx.font = 'bold 12px sans-serif';
  ctx.textAlign = 'center';
  ctx.textBaseline = 'middle';
  ctx.fillText((buoy.id + 1).toString(), 0, 0);

  ctx.restore();
}
